export default {"src":"/_next/static/media/icon_footer_leagues_tungsten.915c572a.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};